module.exports = __webpack_public_path__ + "img/main-page.37ae9641.jpg";